import { UploadedBalanceReport } from '@src/pages/companyInformation/index';

const TGUploadedBalanceReports = () => {
  return <UploadedBalanceReport isCompliments={true} />;
};

export default TGUploadedBalanceReports;
